query PostsList(
  $page: Int
  $rowsPerPage: Int
  $filter: PostsFilterInput
) {
  posts(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      path
      url
      image {
        id
        url(format: SMALL)
      }
      tags {
        id
        title
      }
      publishAt
      accessOnlyViaLink
      createdAt
      updatedAt
    }
  }
}
